export class Country {
  idCountry: number;
  code: string;
  currencySymbol: string | null;
  idLocaleDefault: number | null;
  locked: boolean;

  constructor(
    idCountry: number,
    code: string,
    currencySymbol: string | null,
    idLocaleDefault: number | null,
    locked: boolean,
  ) {
    this.idCountry = idCountry;
    this.code = code;
    this.currencySymbol = currencySymbol;
    this.idLocaleDefault = idLocaleDefault;
    this.locked = locked;
  }

  static fromRaw(raw: any): Country {
    return new Country(
      Number(raw.idCountry),
      String(raw.code),
      raw.currencySymbol ?? null,
      raw.idLocaleDefault ?? null,
      Boolean(raw.locked),
    );
  }

  clone(): Country {
    return new Country(
      this.idCountry,
      this.code,
      this.currencySymbol,
      this.idLocaleDefault,
      this.locked,
    );
  }

  toPayload(): any {
    return {
      idCountry: this.idCountry,
      code: this.code,
      currencySymbol: this.currencySymbol,
      idLocaleDefault: this.idLocaleDefault,
      locked: this.locked,
    };
  }
}
